// src/config/categorias.js
// Configuraciones específicas para el módulo de categorías
import categoriaPlaceholder from '../assets/categoria-placeholder.jpg'

export const CATEGORIAS_NO_IMAGE = categoriaPlaceholder
export const CATEGORIAS_FETCH_CUANTOS = 10